export default __webpack_public_path__ + "static/media/googlePlayBadgeUs.d7245da2.svg";